import axios, { type AxiosRequestConfig } from "axios";
import { API_URL, STAGE } from "../constants";
import type {
  CreateOrganizationInput,
  Organization,
} from "../types/organization.type";

export type CreateOrganizationPayload = CreateOrganizationInput & {
  loadsForwardingEmail: string;
};

export function getOrganizations(
  password: string,
  config?: AxiosRequestConfig
): Promise<{
  organizations: Organization[];
}> {
  return axios
    .get(`${API_URL}/${STAGE}/v2/cms/driver-registrations/organizations`, {
      ...config,
      headers: {
        password,
        ...config?.headers,
      },
    })
    .then((data) => data.data);
}

export function createOrganization(
  password: string,
  organization: CreateOrganizationPayload
): Promise<{ organization: Organization }> {
  return axios
    .post(`${API_URL}/${STAGE}/v2/cms/admin-organizations`, organization, {
      headers: {
        password,
      },
    })
    .then((data) => data.data);
}
